import { render } from "./UsersApp.vue?vue&type=template&id=273aabf4"
import script from "./UsersApp.vue?vue&type=script&lang=js"
export * from "./UsersApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__